/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

import { NestedOption } from '../../../core/nested-option';

import DevExpress from 'devextreme/bundles/dx.all';

export abstract class DxoGaugeIndicator extends NestedOption {
    get arrowLength(): number {
        return this._getOption('arrowLength');
    }
    set arrowLength(value: number) {
        this._setOption('arrowLength', value);
    }

    get backgroundColor(): string {
        return this._getOption('backgroundColor');
    }
    set backgroundColor(value: string) {
        this._setOption('backgroundColor', value);
    }

    get baseValue(): number {
        return this._getOption('baseValue');
    }
    set baseValue(value: number) {
        this._setOption('baseValue', value);
    }

    get beginAdaptingAtRadius(): number {
        return this._getOption('beginAdaptingAtRadius');
    }
    set beginAdaptingAtRadius(value: number) {
        this._setOption('beginAdaptingAtRadius', value);
    }

    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    get horizontalOrientation(): string {
        return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value: string) {
        this._setOption('horizontalOrientation', value);
    }

    get indentFromCenter(): number {
        return this._getOption('indentFromCenter');
    }
    set indentFromCenter(value: number) {
        this._setOption('indentFromCenter', value);
    }

    get length(): number {
        return this._getOption('length');
    }
    set length(value: number) {
        this._setOption('length', value);
    }

    get offset(): number {
        return this._getOption('offset');
    }
    set offset(value: number) {
        this._setOption('offset', value);
    }

    get palette(): string | Array<string> {
        return this._getOption('palette');
    }
    set palette(value: string | Array<string>) {
        this._setOption('palette', value);
    }

    get secondColor(): string {
        return this._getOption('secondColor');
    }
    set secondColor(value: string) {
        this._setOption('secondColor', value);
    }

    get secondFraction(): number {
        return this._getOption('secondFraction');
    }
    set secondFraction(value: number) {
        this._setOption('secondFraction', value);
    }

    get size(): number {
        return this._getOption('size');
    }
    set size(value: number) {
        this._setOption('size', value);
    }

    get spindleGapSize(): number {
        return this._getOption('spindleGapSize');
    }
    set spindleGapSize(value: number) {
        this._setOption('spindleGapSize', value);
    }

    get spindleSize(): number {
        return this._getOption('spindleSize');
    }
    set spindleSize(value: number) {
        this._setOption('spindleSize', value);
    }

    get text(): { customizeText?: Function, font?: DevExpress.viz.Font, format?: DevExpress.ui.format | string, indent?: number } {
        return this._getOption('text');
    }
    set text(value: { customizeText?: Function, font?: DevExpress.viz.Font, format?: DevExpress.ui.format | string, indent?: number }) {
        this._setOption('text', value);
    }

    get type(): string {
        return this._getOption('type');
    }
    set type(value: string) {
        this._setOption('type', value);
    }

    get verticalOrientation(): string {
        return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value: string) {
        this._setOption('verticalOrientation', value);
    }

    get width(): number {
        return this._getOption('width');
    }
    set width(value: number) {
        this._setOption('width', value);
    }
}
